import React, { useCallback, useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import { Link } from "react-router-dom";

function View(props) {
  const { rowData, onBackClick } = props;
  console.log(rowData);
  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <RB.Card.Header className="border-0">
            <h5>View</h5>
            <div className="card-header-action">
              <Link className="btn btn-underline me-2" onClick={onBackClick}>
                Back
              </Link>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            <RB.Row className="mb-3">
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Po Number
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.order_id || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Invoice No
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.invoice_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Plant Location/Code
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.plant_id || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Invert No
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.invert_no || "-"}
                </p>
              </RB.Col>
            </RB.Row>

            {rowData?.invert_item && rowData?.invert_item?.length !== 0 && (
              <RB.Row className="mt-4">
                <RB.Col md={12}>
                  <h6>Po Items</h6>
                  <div className="table-responsive">
                    <RB.Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Item Name</th>
                          <th>Item Code</th>
                          <th>Qty</th>
                          <th>Store Qty</th>
                          {rowData.qcBy && <th>QC Qty</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {rowData?.invert_item.map((item, index) => (
                          <tr key={item.itemId}>
                            <td>{item.product_name}</td>
                            <td>{item.product_code}</td>
                            <td>{`${item.qty} (${item.unit_name})`}</td>
                            <td>{item?.qty_storeBy}</td>
                            {rowData.qcBy && <td>{item.qty_qcBy || "-"}</td>}
                          </tr>
                        ))}
                      </tbody>
                    </RB.Table>
                  </div>
                </RB.Col>
              </RB.Row>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
    </>
  );
}

export default View;
